import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'lift_stressful_dynamic',
    label: 'LIFT_Stressful_Dynamic',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
